import { Link } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const role = session?.role || null;

  const [open, setOpen] = useState(false);

  const logout = () => {
    sessionStorage.clear();
    window.location = "/login";
  };

  return (
    <div className="bg-gradient-to-r from-indigo-700 to-indigo-600 shadow-lg px-6 py-4">

      {/* TOP BAR */}
      <div className="flex justify-between items-center">

        <h1 className="text-lg md:text-xl font-bold text-white tracking-wide">
          बेटी जन्मोत्सव - जिला भोजपुर
        </h1>

        {/* HAMBURGER */}
        <button
          className="md:hidden text-white text-2xl"
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>

        {/* DESKTOP MENU */}
        <div className="hidden md:flex items-center space-x-5">

          <NavLinks role={role} logout={logout} />

        </div>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden mt-4 flex flex-col space-y-3 bg-indigo-600 p-4 rounded-lg">

          <NavLinks role={role} logout={logout} mobile />

        </div>
      )}
    </div>
  );
}

/* =========================
   NAV LINKS COMPONENT
========================= */

function NavLinks({ role, logout, mobile }) {
  const linkClass = mobile
    ? "text-white block"
    : "text-white hover:text-yellow-300";

  return (
    <>
      <Link to="/" className={linkClass}>Home</Link>
      <Link to="/schemes" className={linkClass}>Schemes</Link>
      <Link to="/implementation" className={linkClass}>Implementation</Link>
      <Link to="/gallery" className={linkClass}>Gallery</Link>

      {/* District Admin */}
      {role === "district_admin" && (
        <>
          <Link to="/district" className={linkClass}>Dashboard</Link>
          <Link to="/admin/departments" className={linkClass}>Departments</Link>
          <Link to="/admin/schemes" className={linkClass}>Schemes</Link>
          <Link to="/admin/blocks" className={linkClass}>Blocks</Link>
          <Link to="/admin/users" className={linkClass}>Users</Link>
        </>
      )}

      {/* Department */}
      {role === "department" && (
        <Link to="/department-entry" className={linkClass}>
          Data Entry
        </Link>
      )}

      {/* BDO */}
      {role === "bdo" && (
        <Link to="/bdo" className={linkClass}>
          Block Dashboard
        </Link>
      )}

      {/* Logout */}
      {role && (
        <button
          onClick={logout}
          className="bg-white text-indigo-700 px-4 py-2 rounded mt-2"
        >
          Logout
        </button>
      )}

      {!role && (
        <Link
          to="/login"
          className="bg-yellow-400 text-indigo-900 px-4 py-2 rounded"
        >
          Login
        </Link>
      )}
    </>
  );
}